var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import AddImage from './add-image';
import RenderImage from './render-image';
var ImageUploader = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Upload' : _b, _c = _a.buttonTitle, buttonTitle = _c === void 0 ? 'Upload' : _c, _d = _a.isMultiple, isMultiple = _d === void 0 ? false : _d, listOfImages = _a.listOfImages, _e = _a.acceptedFormats, acceptedFormats = _e === void 0 ? ['image/*'] : _e, onUploadImages = _a.onUploadImages, _f = _a.isUploadDisabled, isUploadDisabled = _f === void 0 ? false : _f, _g = _a.isAddAnother, isAddAnother = _g === void 0 ? false : _g, _h = _a.isDeleteEnabled, isDeleteEnabled = _h === void 0 ? false : _h, onClickDeleteImage = _a.onClickDeleteImage, _j = _a.numberOfImagesInRow, numberOfImagesInRow = _j === void 0 ? 2 : _j, _k = _a.urlKey, urlKey = _k === void 0 ? 'url' : _k, _l = _a.imageResizeMode, imageResizeMode = _l === void 0 ? 'cover' : _l, _m = _a.imageSize, imageSize = _m === void 0 ? {} : _m, renderUploadIcon = _a.renderUploadIcon, renderDeleteIcon = _a.renderDeleteIcon, onImageClick = _a.onImageClick, _o = _a.style, style = _o === void 0 ? {} : _o, onChangeTitle = _a.onChangeTitle;
    var containerRef = useRef(null);
    var _p = useState(0), containerWidth = _p[0], setContainerWidth = _p[1];
    var _q = useState(listOfImages), images = _q[0], setImages = _q[1];
    useEffect(function () {
        setImages(listOfImages);
    }, [listOfImages]);
    var handleTitleChange = function (index, value) {
        var updated = __spreadArray([], images);
        updated[index] = __assign(__assign({}, updated[index]), { title: value });
        setImages(updated);
        if (onChangeTitle) {
            onChangeTitle(index, value);
        }
    };
    useEffect(function () {
        if (containerRef.current) {
            setContainerWidth(containerRef.current.offsetWidth);
        }
    }, []);
    var calculateDimension = useMemo(function () {
        var width = imageSize.width || (containerWidth ? containerWidth / numberOfImagesInRow - 16 : 120);
        var height = imageSize.height || (width * 3) / 4;
        return { width: width, height: height };
    }, [containerWidth, imageSize, numberOfImagesInRow]);
    var imagesWithAddButton = useMemo(function () {
        return isAddAnother ? __spreadArray(__spreadArray([], images), [{ addImagePlaceHolder: true }]) : images;
    }, [images, isAddAnother]);
    return (React.createElement("div", { ref: containerRef, style: __assign({ width: '100%' }, style) },
        imagesWithAddButton.length === 0 && (React.createElement(AddImage, { calculateDimension: calculateDimension, acceptedFormats: acceptedFormats, onUploadImages: onUploadImages, isMultiple: isMultiple, isUploadDisabled: isUploadDisabled, title: title, buttonTitle: buttonTitle, renderUploadIcon: renderUploadIcon })),
        imagesWithAddButton.map(function (item, index) {
            return item.addImagePlaceHolder ? (React.createElement(AddImage, { key: 'add-image', calculateDimension: calculateDimension, acceptedFormats: acceptedFormats, onUploadImages: onUploadImages, isMultiple: isMultiple, isUploadDisabled: isUploadDisabled, title: title, buttonTitle: buttonTitle, renderUploadIcon: renderUploadIcon })) : (React.createElement(RenderImage, { key: item[urlKey] || index, item: item, index: index, calculateDimension: calculateDimension, urlKey: urlKey, isDeleteEnabled: isDeleteEnabled, renderDeleteIcon: renderDeleteIcon, onClickDeleteImage: onClickDeleteImage, onImageClick: onImageClick, imageResizeMode: imageResizeMode, onChangeTitle: handleTitleChange }));
        })));
};
export default ImageUploader;
